
var UnderlineHeadingCollection = (function() {

    function UnderlineHeadingCollection() {
        this.el = document.getElementsByClassName('c-underline-heading');
        this.decor = document.getElementsByClassName('c-underline-heading__decor');
        this.idx = 0;
        this.duration = 3000;
        this.listener = null;
    }

    function animate(collection, cb) {
        var start = performance.now();
        requestAnimationFrame(function animate(time) {
            var elapsed = time - start;
            var progress = Math.min(elapsed / collection.duration, 1);

            collection.decor[collection.idx].style.width = progress * 100 + '%';

            if (elapsed < collection.duration) requestAnimationFrame(animate);
            else cb();
        });
    }

    function next(collection) {
        collection.decor[collection.idx].style.width = 0;
        if (++collection.idx >= collection.el.length) collection.idx = 0;
        collection.listener(collection.idx);
        animate(collection, next.bind(this, collection));
    }

    UnderlineHeadingCollection.prototype.start = function() {
        animate(this, next.bind(this, this));
    }

    UnderlineHeadingCollection.prototype.addNextListener = function(listener) {
        this.listener = listener;
    }

    return UnderlineHeadingCollection;
}());

export default UnderlineHeadingCollection;
